module.exports = __webpack_public_path__ + "img/warranty.893a7cd0.png";